/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ActiveCustomer } from './ActiveCustomer.js';
import {
    ActiveCustomerFromJSON,
    ActiveCustomerFromJSONTyped,
    ActiveCustomerToJSON,
} from './ActiveCustomer.js';

/**
 * 
 * @export
 * @interface ActiveCustomerIdResponse
 */
export interface ActiveCustomerIdResponse {
    /**
     * 
     * @type {ActiveCustomer}
     * @memberof ActiveCustomerIdResponse
     */
    data?: ActiveCustomer;
    /**
     * 
     * @type {number}
     * @memberof ActiveCustomerIdResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveCustomerIdResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveCustomerIdResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ActiveCustomerIdResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ActiveCustomerIdResponse interface.
 */
export function instanceOfActiveCustomerIdResponse(value: object): boolean {
    return true;
}

export function ActiveCustomerIdResponseFromJSON(json: any): ActiveCustomerIdResponse {
    return ActiveCustomerIdResponseFromJSONTyped(json, false);
}

export function ActiveCustomerIdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveCustomerIdResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ActiveCustomerFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ActiveCustomerIdResponseToJSON(value?: ActiveCustomerIdResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ActiveCustomerToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

